import moment from "moment";
moment.locale("pt-br");

export default {
  date: (date) => {
    if (date) {
      return (
        new Date(date)
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("/")
      );
    } else {
      return ""
    }
  },
  dateTime: (date) => {
    return moment(date).format("DD/MM/YYYY HH:mm");
  },
  receiptDate: (date) => {
    return moment(date).format("DD/MM/YYYY");
  },
  defaultDate: (date) => {
    return date.substring(0, 10);
  },
  systemDate(date) {
    return moment(date).format("YYYY-MM-DD");
  },
};
